'use client';

// This provider is used to work around an error reported for the Jotai package
// (https://github.com/pmndrs/jotai/discussions/2579#discussioncomment-11633408), but is actually caused by an error in
// Turbopack. Once the error is fixed, this wrapping provider can be removed.
import { Provider } from 'jotai';

const JotaiProvider = ({ children }) => <Provider>{children}</Provider>;

export default JotaiProvider;
